// extracted by mini-css-extract-plugin
module.exports = {"edit-image-box":"style_edit-image-box__3xwAY"};